// NPM Imports
import React, { Fragment, useState } from "react";
import { Tooltip } from "@revvsales/components";

// Internal Imports
import ReferralPopup from "../../../SettingsWrapper/ReferralPopup";

export default function ReferralBtn() {
  const [showPopUp, togglePopUp] = useState(false);

  return (
    <Fragment>
      <div>
        <Tooltip placement="bottom" overlay="Refer and get Amazon gift cards">
          <span
            data-test="cta-referral-btn"
            className="referral-btn-wrapper"
            onClick={() => togglePopUp(true)}
            onKeyPress={() => {}}
            tabIndex="0"
            role="button">
            <span aria-label="referral-gift-wrapper" role="img">
              🎁
            </span>
          </span>
        </Tooltip>
      </div>
      {showPopUp && <ReferralPopup closePopup={() => togglePopUp(false)} />}
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/Buttons/referralBtn/index.js